import styled from "styled-components";

/**
 * Estilo para o componente Image
 * Configurações dinâmicas de dimensões, bordas e comportamento de ajuste.
 */
export const StyledImage = styled.img.withConfig({
  shouldForwardProp: (prop) =>
    !["$width", "$height", "$borderRadius", "$objectFit"].includes(prop),
})<{
  $width?: string;
  $height?: string;
  $borderRadius?: string;
  $objectFit?: "cover" | "contain" | "fill" | "none" | "scale-down";
}>`
  width: ${({ $width }) => $width || "auto"};
  height: ${({ $height }) => $height || "auto"};
  border-radius: ${({ $borderRadius, theme }) =>
    $borderRadius || theme.borderRadius.none};
  object-fit: ${({ $objectFit }) => $objectFit || "cover"};
`;
